import { Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { ContactUsService } from '../shared/services/contact-us.service';
import { LoadingOverlayComponent } from '../shared/components/loading-overlay/loading-overlay.component';
import { extractErrorMessage } from '../shared/functions/extract-error-message.helper';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    LoadingOverlayComponent
  ],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss'
})
export class ContactComponent {

  private service = inject(ContactUsService)
  loading = signal(false)
  displaySuccessMessage = signal(false)
  contactForm = new FormGroup({
    name: new FormControl('', {
      validators: [
        Validators.required
      ]
    }),
    email_address: new FormControl('', {
      validators: [
        Validators.required,
        Validators.email
      ]
    }),
    message: new FormControl('', {
      validators: [
        Validators.required
      ]
    })
  })

  async submit() {
    if (this.contactForm.valid) {
      try {
        this.loading.set(true)
        const apiResponse = await firstValueFrom(
          this.service.submitContactForm(this.contactForm.value)
        );
        if(apiResponse) {
          this.displaySuccessMessage.set(true)
        }

      } catch (err) {
        console.log(extractErrorMessage(err))
      } finally {
        this.loading.set(false)
      }

    } else {
      this.contactForm.markAllAsTouched()
    }
  }
}
